export default [
    {
        key: '0',
        label: 'Airtable Records',
        data: 'Airtable Layers',
        isVisible: true,
        children: [
            {
                key: '0-0',
                label: 'Airtable Record Layer',
                data: 'Airtable Record Layer',
                isVisible: true,
                layer: 'airtable-records',
            },
            {
                key: '0-1',
                label: 'Airtable Record Buffer',
                data: 'Airtable Buffer Layer',
                isVisible: true,
                layer: 'airtable-buffer-layer',
            },
        ],
    },
];
